import React, { createContext, useContext, FC, useState } from 'react';

export type CustomTextInput = 'zip' | 'symptom' | 'default';

export const CustomTextInputContext = createContext<{
    customTextInput: CustomTextInput;
    setCustomTextInput: (CustomTextInput: CustomTextInput) => void;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
}>({ customTextInput: 'default', setCustomTextInput: () => {} });

export const CustomTextInputProvider: FC<{
    initialMode: CustomTextInput;
    children: React.ReactNode;
}> = ({ initialMode, children }) => {
    const [mode, setMode] = useState(initialMode);
    return (
        <CustomTextInputContext.Provider
            value={{ customTextInput: mode, setCustomTextInput: setMode }}
        >
            {children}
        </CustomTextInputContext.Provider>
    );
};

export const useCustomTextInput = () => useContext(CustomTextInputContext);
